module.exports = __webpack_public_path__ + "img/floor2_5.b1682255.jpg";